// extracted by mini-css-extract-plugin
module.exports = {"viewDetails":"ApplicationStatusChangeErrorNotification_viewDetails__12ssI"};